// import ut from "../common/libs/utils";
import i18n from "./index";
import $http from "../api/http";
// import $http from "@/utils/request";
import $$store from "../store";
let loadLang = {
    /**
     * 加载远程语言包
     * @param {*} params
     */
    loadRemoteLangs(params) {
        let that = this;
        let LOG_TAG = "[容器] [loadRemoteLangs]";
        return new Promise(async (resolve, reject) => {
            // const langKey = ut.getOSlanguage();
            const langKey = 'en'

            // 将远程语言包合并到i18n
            function mergeLocaleMessage(moduleName, langPackageRemotes) {
                console.log(LOG_TAG, "合并开始", moduleName,langPackageRemotes);
                if (langPackageRemotes) {
                    let langPackageRemotesTemp = _.cloneDeep(langPackageRemotes);
                    _.forEach(langPackageRemotesTemp, (langPackageRemote, key) => {
                        const serviceType = langPackageRemote["@ServiceType"];
                        // 3是接口服务的语言包，统一注入到公共语言包中
                        if (serviceType === "3") {
                            key = "sup8-h5plus-docker";
                        }
                        if (key === "sup8-h5plus-docker") {
                            i18n.mergeLocaleMessage(langKey, langPackageRemote);
                        } else {
                            const tempLangDic = {};
                            tempLangDic[langKey] = langPackageRemote;

                            that.mergeModule(i18n, tempLangDic, key);
                        }
                    });
                }
                console.log(LOG_TAG, "合并结束", moduleName);
                resolve();
            }

            params.moduleName = params.moduleName || "sup8-h5-app-amison";

            console.log(LOG_TAG, "开始加载", params.moduleName);
            // if (window.dockerConfig.loadRemoteLangs) {
                // 是否已经加载了语言包
                let langPackageRemotes = _.cloneDeep(
                    $$store.state.loadedLangPackages[params.moduleName]
                );
                if (!langPackageRemotes) {
                    langPackageRemotes = {};
                    langPackageRemotes[params.moduleName] = {};

                    $$store.commit("set_loadedLangPackages",langPackageRemotes);
                    await $http
                        .request({
                            method: "get",
                            url: `/tt/lang/v1/static/load/${params.moduleName}?eno=${$$store.state.eNo}`,
                        })
                        .then(async (httpRes) => {
                            if (httpRes) {
                                let jsUrls = _.get(httpRes, "data.javaScriptUrls");
                                if (!jsUrls || jsUrls.length <= 0) { 
                                    jsUrls=['default']
                                }
                                
                                if (jsUrls && jsUrls.length > 0) {
                                    const strList = await Promise.all(
                                        jsUrls.map(async (item) => {
                                            let str = ""
                                            if (item === 'default') {
                                                str = `{"@LangType": "${langKey}","@ServiceId": "${params.moduleName}","@ServiceType": "1"}`
                                            } else {
                                                let httpRes2 = await $http.request({
                                                    method: "get",
                                                    url: item,
                                                    langIgnoreFlag: true,
                                                });
                                                let n = _.indexOf(httpRes2, "=");
                                                str = httpRes2.substr(n + 1);
                                            }
                                            return str;
                                        })
                                    );
                                    strList.forEach(str => {
                                        let langPackageRemote = JSON.parse(str);
                                        let moduleName = langPackageRemote["@ServiceId"];
                                        langPackageRemotes[params.moduleName][moduleName] = langPackageRemote;
                                    })
                                    // for (let index = 0; index < jsUrls.length; index++) {
                                    //     let jsUrl = jsUrls[index];
                                    //     let str = '';

                                    //     if (jsUrl==='default') { 
                                    //         str = `{"@LangType": "${langKey}","@ServiceId": "${params.moduleName}","@ServiceType": "1"}`
                                    //     } else {
                                    //         let httpRes2 = await $http.request({
                                    //             method: "get",
                                    //             url: jsUrl,
                                    //             params: {
                                    //                 langIgnoreFlag: true
                                    //             }
                                    //         });
    
                                    //         let n = _.indexOf(httpRes2, "=");
                                    //          str = httpRes2.substr(n + 1);
                                    //     }

                                    //     let langPackageRemote = JSON.parse(str);

                                    //     let moduleName = langPackageRemote["@ServiceId"];
                                    //     langPackageRemotes[params.moduleName][moduleName] =
                                    //         langPackageRemote;
                                    // }

                                    mergeLocaleMessage(params.moduleName,_.cloneDeep(langPackageRemotes[params.moduleName]));
                                    $$store.commit("set_loadedLangPackages",langPackageRemotes);


                                } else {
                                    $$store.commit("set_loadedLangPackages", params.moduleName);
                                    console.log(LOG_TAG, "无远程语言包", params.moduleName);
                                    resolve();
                                }
                            }
                        });
                } else {
                    console.log(LOG_TAG, "使用缓存语言包", params.moduleName);
                    mergeLocaleMessage(params.moduleName, langPackageRemotes);
                }
            // } else {
            //     console.log(LOG_TAG, "参数设置不加载远程语言包", params.moduleName);
            //     resolve();
            // }
        });
    },
    loadRemoteLangs_MP(params) { 
       return this.loadRemoteLangs(params);
    },

    /**
     * 将模块的语言包合并到i18n中
     * @param {*} i18n
     * @param {*} langs 模块的语言包
     * @param {*} name  模块名称
     * @returns
     */
    mergeModule(i18n, langs, name) {
        const langKeys = Object.keys(langs);
        for (const langKey of langKeys) {
            let temp = {};
            if (name) {
                temp[name] = langs[langKey];
            } else {
                temp = langs[langKey];
            }
            i18n.mergeLocaleMessage(langKey, temp);
        }
    },
};
export default loadLang;
